/* eslint-disable */
//TODO eslint отключен, нужен рефакторинг
import * as React from "react";
import { findDOMNode } from "react-dom";

import { emailIsValid, getRegionById } from "../../utils";
import { ConfirmModal } from "../confirm_modal/confirm_modal";
import { ContactsField } from "./contacts_field/contacts_field";
import {
  DescriptionField,
  maxDescriptionLength
} from "./description_field/description_field";
import { EmploymentField } from "./employment_field/employment_field";
import { FormField } from "./form_field/form_field";
import { RecaptchaField } from "./recaptcha_field/recaptcha_field";
import { RegionField } from "./region_field/region_field";
import { SalaryField } from "./salary_field/salary_field";
import { SpecializationField } from "./specialization_field/specialization_field";
import { IVacancyFormProps } from "./vacancy_form_props";
import {
  createVacancyFormState,
  IVacancyFormState
} from "./vacancy_form_state";
import { WorkExperienceField } from "./work_experience_field/work_experience";

import * as styles from "./vacancy_form.css";
import { Button, LinkButton } from "@cian/ui-kit";

const requireFieldClassName: string = styles["field-value_require"];
const fieldClassName: string = styles["field-value"];

export class VacancyForm extends React.Component<
  IVacancyFormProps,
  IVacancyFormState
> {
  public constructor(props: IVacancyFormProps) {
    super(props);

    this.state = createVacancyFormState(
      this.props.vacancy,
      this.props.regions[0]
    );
  }

  public componentDidMount() {
    this.setState({
      contactPhone:
        (this.props.vacancy && `7${this.props.vacancy.contactPhone}`) || ""
    });
  }

  public componentDidUpdate() {
    const formIsFilled: boolean = this.formIsFilled();
    if (this.state.formIsFilled !== formIsFilled) {
      this.setState({ formIsFilled });
    }
  }

  public render() {
    return (
      <div className={styles["form"]}>
        <h1 className={styles["title"]}>{this.props.title}</h1>
        <FormField label="Специализация">
          <SpecializationField
            isValid={this.state.specializationIsValid}
            value={this.state.specialization}
            change={this.specializationChanged.bind(this)}
            className={
              this.specializationIsFilled()
                ? fieldClassName
                : requireFieldClassName
            }
          />
        </FormField>
        <FormField label="Город">
          <RegionField
            width={320}
            className={styles["field-value"]}
            region={this.state.region}
            onSelect={value =>
              this.setState({
                region: getRegionById(this.props.regions, value)
              })
            }
            regions={this.props.regions}
          />
        </FormField>
        <FormField label="Зарплата">
          <SalaryField
            minValue={this.state.minSalary}
            maxValue={this.state.maxSalary}
            byAgreementValue={this.state.byAgreementSalary}
            minChange={this.minSalaryChanged.bind(this)}
            maxChange={this.maxSalaryChanged.bind(this)}
            byAgreementChange={this.byAgreementSalaryChanged.bind(this)}
            isValid={this.state.salaryIsValid}
            className={
              this.salaryIsFilled() ? fieldClassName : requireFieldClassName
            }
          />
        </FormField>
        <FormField label="Опыт работы">
          <WorkExperienceField
            isValid={this.state.workExperienceIsValid}
            className={
              this.workExperienceIsFilled()
                ? fieldClassName
                : requireFieldClassName
            }
            workExperienceValue={this.state.workExperience}
            noWorkExperienceValue={this.state.noWorkExperience}
            workExperienceChange={this.workExperienceChanged.bind(this)}
            noWorkExperienceChange={this.noWorkExperienceChanged.bind(this)}
            workExperienceBlur={this.workExperienceFieldBlur.bind(this)}
          />
        </FormField>
        <FormField label="Тип занятости">
          <EmploymentField
            className={styles["field-value"]}
            value={this.state.employment}
            change={(value) => this.setState({ employment: value })}
          />
        </FormField>
        <FormField label="Описание вакансии">
          <DescriptionField
            isValid={this.state.descriptionIsValid}
            className={
              this.descriptionIsFilled()
                ? fieldClassName
                : requireFieldClassName
            }
            value={this.state.description}
            change={this.descriptionChanged.bind(this)}
          />
        </FormField>
        <FormField label="Контакты для связи" labelSup="Будут видны кандидатам">
          <ContactsField
            isValid={this.state.contactsIsValid}
            className={
              this.contactsIsFilled() ? fieldClassName : requireFieldClassName
            }
            phoneValue={this.state.contactPhone}
            emailValue={this.state.contactEmail}
            phoneChange={value =>
              this.setState({ contactPhone: value, contactsIsValid: true })
            }
            emailChange={(e, value) =>
              this.setState({ contactEmail: value, contactsIsValid: true })
            }
          />
        </FormField>
        {this.props.useRecaptcha && (
          <div className={styles["recaptcha_field"]}>
            <div
              className={
                this.state.recaptcha ? fieldClassName : requireFieldClassName
              }
            >
              <RecaptchaField
                isValid={this.state.recaptchaIsValid}
                sitekey={this.props.recaptchaSitekey}
                onExecute={res => this.setState({ recaptcha: res })}
                onExpired={() => this.setState({ recaptcha: "" })}
              />
            </div>
          </div>
        )}
        <div className={styles["divider"]} />
        <FormField label="">
          <div className="buttons">
            <Button
              data-name="PublishFreeButton"
              size="XS"
              disabled={!this.state.formIsFilled}
              theme="fill_primary"
              onClick={this.saveVacancy.bind(this)}
            >
              Опубликовать бесплатно
            </Button>
            <LinkButton size="XS" theme="fill_white_primary" href="/vacancies-realtors" onClick={this.cancelAddVacancy.bind(this)}>
              Отмена
            </LinkButton>
            {this.props.isPublishError && (
              <div className={styles["publish_error"]}>
                <span className={styles["publish_error-img"]} />
                <span className={styles["publish_error-text"]}>
                  Не удалось опубликовать вакансию. Повторите попытку позже.
                </span>
              </div>
            )}
          </div>
        </FormField>
        <ConfirmModal
          isOpen={this.state.cancelAddVacancyModalOpened}
          onClose={() =>
            this.setState({ cancelAddVacancyModalOpened: false })
          }
          onConfirm={() => (window.location.pathname = "/vacancies-realtors")}
          headText="Отменить и перейти к поиску вакансий?"
          confirmText="Да"
          dismissText="Нет, продолжить публикацию"
        />
      </div>
    );
  }

  private saveVacancy() {
    if (!this.formIsValid() || !this.state.formIsFilled) {
      const elem = findDOMNode(this) as Element;
      elem.scrollIntoView();

      return;
    }

    this.props.onSubmit(
      {
        contactEmail: this.state.contactEmail,
        contactPhone: this.state.contactPhone,
        description: this.state.description,
        employment: this.state.employment,
        id: this.state.id,
        maxSalary: this.state.maxSalary,
        minSalary: this.state.minSalary,
        region: this.state.region,
        specialization: this.state.specialization,
        workExperience: this.state.workExperience
      },
      this.state.recaptcha
    );
  }

  private formIsValid() {
    let count = 0;
    
    if (
      (this.state.contactPhone.length > 1 &&
        this.state.contactPhone.length !== 10) ||
      (!!this.state.contactEmail && !emailIsValid(this.state.contactEmail))
    ) {
      count++;
      this.setState({ contactsIsValid: false });
    }
    if (
      !!this.state.minSalary &&
      !!this.state.maxSalary &&
      this.state.minSalary > this.state.maxSalary
    ) {
      count++;
      this.setState({ salaryIsValid: false });
    }

    return count === 0;
  }

  private cancelAddVacancy(event: MouseEvent) {
    event.preventDefault();
    this.setState({ cancelAddVacancyModalOpened: true });
  }

  private specializationChanged(value: string) {
    this.setState({
      specialization: value,
      specializationIsValid: true
    });
  }

  private descriptionChanged(e: React.ChangeEvent<HTMLTextAreaElement>, value: string) {
    this.setState({
      description:
        value.length > maxDescriptionLength
          ? value.slice(0, maxDescriptionLength)
          : value,
      descriptionIsValid: true
    });
  }

  private byAgreementSalaryChanged(e: React.ChangeEvent<HTMLInputElement>, value: boolean) {
    this.setState({
      byAgreementSalary: value,
      maxSalary: undefined,
      minSalary: undefined,
      salaryIsValid: true
    });
  }

  private minSalaryChanged(value: number) {
    this.setState({
      byAgreementSalary: false,
      minSalary: value,
      salaryIsValid: true
    });
  }

  private maxSalaryChanged(value: number) {
    this.setState({
      byAgreementSalary: false,
      maxSalary: value,
      salaryIsValid: true
    });
  }

  private workExperienceChanged(value: number | void) {
    this.setState({
      noWorkExperience: false,
      workExperience: typeof value === "number" ? value : undefined,
      workExperienceIsValid: true
    });
  }

  private workExperienceFieldBlur() {
    if (this.state.workExperience === 0) {
      this.setState({
        noWorkExperience: true,
        workExperience: undefined,
        workExperienceIsValid: true
      });
    }
  }

  private noWorkExperienceChanged(e: React.ChangeEvent<HTMLInputElement>, value: boolean) {
    this.setState({
      noWorkExperience: value,
      workExperience: undefined,
      workExperienceIsValid: true
    });
  }

  private formIsFilled() {
    return (
      this.specializationIsFilled() &&
      this.salaryIsFilled() &&
      this.regionIsFilled() &&
      this.workExperienceIsFilled() &&
      this.descriptionIsFilled() &&
      this.contactsIsFilled() &&
      (!this.props.useRecaptcha || !!this.state.recaptcha)
    );
  }

  private regionIsFilled(): boolean {
    return !!this.state.region && !!this.state.region.id;
  }

  private specializationIsFilled(): boolean {
    return !!this.state.specialization;
  }

  private salaryIsFilled(): boolean {
    return (
      !!this.state.maxSalary ||
      !!this.state.minSalary ||
      this.state.byAgreementSalary
    );
  }

  private workExperienceIsFilled(): boolean {
    return (
      typeof this.state.workExperience === "number" ||
      this.state.noWorkExperience
    );
  }

  private descriptionIsFilled(): boolean {
    return !!this.state.description;
  }

  private contactsIsFilled(): boolean {
    return this.state.contactPhone.length > 1 || !!this.state.contactEmail;
  }
}
